import * as types from './types';

const mutations = {
  // RESET
  [types.RESET](state) {
    state.applications = [];
    state.application = {};
  },
  // INITIAL_LOADING
  [types.INITIAL_LOADING_PENDING](state) {
    state.initialLoading = true;
  },
  [types.INITIAL_LOADING_FULFILLED](state) {
    state.initialLoading = false;
  },
  [types.INITIAL_LOADING_ERROR](state) {
    state.initialLoading = false;
  },
  // FETCH_APPLICATIONS
  [types.FETCH_APPLICATIONS_PENDING](state) {
    state.fetchApplicationsPending = true;
  },
  [types.FETCH_APPLICATIONS_FULFILLED](state, { data }) {
    state.applications = data.data;
    state.fetchApplicationsPending = false;
  },
  [types.FETCH_APPLICATIONS_ERROR](state) {
    state.fetchApplicationsPending = false;
  },
  // UPDATE_APPLICATION
  [types.UPDATE_APPLICATION_PENDING](state) {
    state.updateApplicationPending = true;
  },
  [types.UPDATE_APPLICATION_FULFILLED](state) {
    state.updateApplicationPending = false;
  },
  [types.UPDATE_APPLICATION_ERROR](state) {
    state.updateApplicationPending = false;
  },
};

export default mutations;
